// get height of text area and width of text area using ref

import { TextAreaRef } from 'antd/es/input/TextArea';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useGetHeightTextArea = () => {
  const defaultHeight = 570;
  const textAreaRef = useRef<TextAreaRef>(null);
  const [height, setHeight] = useState(defaultHeight); // Start with minHeight

  // Helper function to get the current textarea element
  const getTextArea = useCallback(() => {
    return textAreaRef.current?.resizableTextArea?.textArea || null;
  }, []);

  // Update height based on the textarea's client height
  const updateHeight = useCallback(() => {
    const textArea = getTextArea();
    if (textArea) {
      const clientHeight = textArea.clientHeight;
      setHeight(clientHeight);
    }
  }, [getTextArea]);

  useEffect(() => {
    const textArea = getTextArea();
    if (textArea) {
      // using observer to listen to the height of the text area
      const observer = new ResizeObserver(updateHeight);
      observer.observe(textArea);
      updateHeight();
      return () => {
        observer.disconnect();
      };
    }
  }, [updateHeight, getTextArea]);

  return { height, textAreaRef };
};
